import { useMemo } from "react";
import { type MinimalQueryResult } from "@jsq/ds/types";
import { useProfileInvestmentAccountDetailsQuery } from "~/graphql/supergraphHooks";
import { buildCompareData } from "./utils";
import type { InvestorCompareData } from "./types";
import type { InvestmentAccountNode } from "../CompareTable/utils";

export const useInvestorAccountsComparison = ({
  arenaId,
  profileGuid,
  investmentAccountId,
  currentAccountNode,
}: {
  arenaId: number | undefined;
  profileGuid: string | null;
  investmentAccountId: number | null;
  currentAccountNode: InvestmentAccountNode | null;
}): { compareData: InvestorCompareData | null; queryResult: MinimalQueryResult } => {
  const skip = arenaId === undefined || !profileGuid;

  const queryResult = useProfileInvestmentAccountDetailsQuery({
    variables: {
      arenaId: arenaId ?? 0,
      profileGuid: profileGuid ?? "",
    },
    skip,
    fetchPolicy: "cache-and-network",
  });

  const compareData = useMemo(
    () =>
      buildCompareData(
        queryResult.data?.profileInvestmentAccountDetails ?? [],
        currentAccountNode,
        investmentAccountId,
        arenaId,
      ),
    [queryResult.data, currentAccountNode, investmentAccountId, arenaId],
  );

  return { compareData, queryResult };
};
